var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"calendar",staticClass:"vendasta-calendar embed",attrs:{"id":"vendasta-calendar","src":_vm.calendarUrl,"title":"Vendasta Calendar"}})
}
var staticRenderFns = []

export { render, staticRenderFns }